import { createBrowserRouter } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import { LoadingSpinner } from '@/components';

// Lazy load pages for code splitting
const Home = lazy(() => import('./pages/Home'));
const FindInformation = lazy(() => import('./pages/FindInformation'));
const ServiceDirectoryPage = lazy(() => import('./pages/ServiceDirectoryPage'));
const ComingSoon = lazy(() => import('./pages/ComingSoon'));
const CompassPage = lazy(() => import('./pages/CompassPage'));
const UmbrellaPage = lazy(() => import('./pages/UmbrellaPage'));
const SearchResultsPage = lazy(() => import('./pages/SearchResultsPage'));
const EventsPage = lazy(() => import('./pages/EventsPage'));

// Suspense wrapper for lazy-loaded components
const SuspenseWrapper = ({ children }: { children: React.ReactNode }) => (
  <Suspense fallback={<div className="flex items-center justify-center min-h-screen"><LoadingSpinner /></div>}>
    {children}
  </Suspense>
);

export const router = createBrowserRouter([
  {
    path: '/',
    element: <SuspenseWrapper><UmbrellaPage /></SuspenseWrapper>
  },
  {
    path: '/resource-hub',
    element: <SuspenseWrapper><Home /></SuspenseWrapper>
  },
  {
    path: '/find-information',
    element: <SuspenseWrapper><FindInformation /></SuspenseWrapper>
  },
  {
    path: '/quiz',
    element: <SuspenseWrapper><div className="container mx-auto py-12"><h1 className="text-3xl font-bold">Resource Finder Quiz</h1><p className="text-muted-foreground mt-4">Coming soon...</p></div></SuspenseWrapper>
  },
  {
    path: '/services-directory',
    element: <SuspenseWrapper><ServiceDirectoryPage /></SuspenseWrapper>
  },
  {
    path: '/events',
    element: <SuspenseWrapper><EventsPage /></SuspenseWrapper>
  },
  {
    path: '/resources/:category',
    element: <SuspenseWrapper><div className="container mx-auto py-12"><h1 className="text-3xl font-bold">Resources</h1><p className="text-muted-foreground mt-4">Coming soon...</p></div></SuspenseWrapper>
  },
  {
    path: '/compass',
    element: <SuspenseWrapper><CompassPage /></SuspenseWrapper>
  },
  {
    path: '/search',
    element: <SuspenseWrapper><SearchResultsPage /></SuspenseWrapper>
  },
  {
    path: '/coming-soon',
    element: <SuspenseWrapper><ComingSoon /></SuspenseWrapper>
  }
]);
